import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import type { WhatsAppIntegrationLike } from "@/lib/whatsapp-integration-label";

export type WorkspaceIntegrationsMap = Map<string, WhatsAppIntegrationLike>;

export function useWorkspaceIntegrationsMap(workspaceId: string | null): WorkspaceIntegrationsMap {
  const [map, setMap] = useState<WorkspaceIntegrationsMap>(() => new Map());

  useEffect(() => {
    if (!workspaceId) {
      setMap(new Map());
      return;
    }

    let cancelled = false;

    (async () => {
      const { data, error } = await supabase
        .from("integrations")
        .select("id, instance_identifier, provider, config")
        .eq("workspace_id", workspaceId);

      if (cancelled) return;

      if (error) {
        console.error("Erro ao carregar integrações para rótulos:", error);
        setMap(new Map());
        return;
      }

      const next = new Map<string, WhatsAppIntegrationLike>();
      for (const row of data ?? []) {
        next.set(row.id, {
          instance_identifier: row.instance_identifier,
          provider: row.provider,
          config: (row.config ?? null) as NonNullable<WhatsAppIntegrationLike>["config"],
        });
      }
      setMap(next);
    })();

    return () => {
      cancelled = true;
    };
  }, [workspaceId]);

  return map;
}
